(function () {
  'use strict';

  var STORAGE_KEY = 'saigu_inquiry_clicks';
  var MAX_STORED_EVENTS = 50;

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  }

  function getClickType(anchor) {
    var href = anchor.href || '';
    var rawHref = anchor.getAttribute('href') || '';
    var text = cleanText(anchor.innerText || anchor.getAttribute('aria-label') || anchor.title);
    var className = anchor.className || '';
    var path = '';

    if (rawHref.charAt(0) === '#') return '';
    try {
      path = new URL(href, window.location.origin).pathname.toLowerCase();
    } catch (error) {}

    var combined = (href + ' ' + text + ' ' + className).toLowerCase();
    var quoteSignal = (path + ' ' + text + ' ' + className).toLowerCase();

    if (combined.indexOf('wa.me') > -1 || combined.indexOf('whatsapp') > -1) return 'whatsapp';
    if (combined.indexOf('mailto:') > -1 || combined.indexOf('email') > -1) return 'email';
    if (quoteSignal.indexOf('/pages/contact') > -1 || quoteSignal.indexOf('quote') > -1 || quoteSignal.indexOf('inquiry') > -1) return 'quote';
    return '';
  }

  function getProductContext() {
    var productJson = document.querySelector('[type="application/json"][data-product-json]');
    if (productJson && productJson.textContent) {
      try {
        var parsed = JSON.parse(productJson.textContent);
        if (parsed && parsed.title) return cleanText(parsed.title);
      } catch (error) {}
    }

    var titles = document.querySelectorAll('.product_title, .t4s-product__title, h1');
    for (var index = 0; index < titles.length; index += 1) {
      var title = titles[index];
      if (title.offsetParent === null && title.getClientRects().length === 0) continue;
      var value = cleanText(title.textContent);
      if (!value || value.toLowerCase() === 'saigu.store') continue;
      return value;
    }
    return '';
  }

  function getLinkLabel(anchor) {
    return cleanText(anchor.getAttribute('data-saigu-inquiry-label') || anchor.innerText || anchor.getAttribute('aria-label') || anchor.title || anchor.href);
  }

  function saveLocalEvent(payload) {
    try {
      var existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      existing.unshift(payload);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existing.slice(0, MAX_STORED_EVENTS)));
    } catch (error) {}
  }

  function pushAnalyticsEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'saigu_b2b_inquiry_click',
      inquiry_type: payload.inquiry_type,
      inquiry_label: payload.inquiry_label,
      page_path: payload.page_path,
      page_title: payload.page_title,
      product_context: payload.product_context,
      link_url: payload.link_url
    });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'saigu_b2b_inquiry_click', {
        inquiry_type: payload.inquiry_type,
        inquiry_label: payload.inquiry_label,
        page_path: payload.page_path,
        page_title: payload.page_title,
        product_context: payload.product_context,
        link_url: payload.link_url
      });
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish('saigu_b2b_inquiry_click', payload);
      } catch (error) {}
    }
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor) return;

    var inquiryType = getClickType(anchor);
    if (!inquiryType) return;

    var payload = {
      event_name: 'saigu_b2b_inquiry_click',
      inquiry_type: inquiryType,
      inquiry_label: getLinkLabel(anchor),
      page_path: window.location.pathname,
      page_title: cleanText(document.title),
      product_context: getProductContext(),
      link_url: anchor.href,
      occurred_at: new Date().toISOString()
    };

    saveLocalEvent(payload);
    pushAnalyticsEvent(payload);
  }, true);

  window.saiguInquiryTrackingReady = true;
})();
